/// <reference path="../frame/gridviewselect/availabletreefieldcomponent.tsx" />
import dom from "../../dist/jsx-render/dom";
import { IDocumentInfo } from "../Model/IDocumentInfo";
import { MsoTable } from "./Table/MsoTable";
import { ITableColumn } from "./Table/ITableColumn";
import { TableColumnTypes } from "./Table/TableColumnTypes";
import { EditTypes } from "./Table/EditTypes";
import { TableColumnAlign } from "./Table/TableColumnAlign";
import { app } from "../Frame/App";
import { Picture } from "../Frame/Picture";
import { PopupEditDocument } from "../Pages/Measure/PopupEditDocument";
import { DocumentsControl } from "./Dynamic/DocumentsControl";
import { DynPopup } from "../Components/DynPopup";

export class DocumentListProps {
    public data?: IDocumentInfo[];
    public jsonData?: string;
    public fixed?: boolean;
    public measureId: number;
    public parentElement: HTMLElement;
    public allowEdit?: boolean;
    public allowMove?: boolean;
    public allowDelete?: boolean;
    public columns?: string;
    public settingsName?: string;
    public deleteHandler?: (id: number) => JQuery.jqXHR<any>;
    public parentControl?: DocumentsControl;

    public afterMoveEvent?: (model: IDocumentInfo) => void;
}

export class DocumentList {
    protected props: DocumentListProps;

    protected data: IDocumentInfo[];
    protected table: MsoTable;
    protected element: HTMLDivElement;

    protected colDownload: ITableColumn;
    protected colFileName: ITableColumn;
    protected colIsPicture: ITableColumn;
    protected colBlockName: ITableColumn;
    protected colFieldName: ITableColumn;
    protected colLink: ITableColumn;
    protected colComment: ITableColumn;
    protected colAnnotation: ITableColumn;
    protected colUserName: ITableColumn;
    protected colDate: ITableColumn;
    protected colDelete: ITableColumn;

    constructor(props: DocumentListProps) {
        this.props = props;

        this.createColumns();

        if (this.props.jsonData && this.props.jsonData.length > 0) {
            this.data = JSON.parse(this.props.jsonData);
        } else if (this.props.data) {
            this.data = this.props.data;
        } else {
            this.data = [];
        }
        this.createTable();
    }

    protected createColumns = () => {
        this.colDownload = { number: 1, type: TableColumnTypes.Custom, dataField: "download", cssClass: "dc-download", defaultWidth: "5%", align: TableColumnAlign.Center };
        this.colFileName = { number: 2, type: TableColumnTypes.String, dataField: "fileName", cssClass: "dc-file-name", headerText: Resources.Begriffe.fileName, defaultWidth: "20%" };
        this.colLink = { number: 3, type: TableColumnTypes.String, dataField: "link", cssClass: "dc-link", headerText: Resources.Begriffe.link, defaultWidth: "15%" };
        this.colComment = { number: 4, type: TableColumnTypes.String, dataField: "comment", cssClass: "dc-comment", headerText: Resources.Common.comment, defaultWidth: "15%" };
        this.colAnnotation = { number: 5, type: TableColumnTypes.String, dataField: "annotation", cssClass: "dc-annotation", headerText: Resources.Common.annotation, defaultWidth: "15%" };
        this.colUserName = { number: 6, type: TableColumnTypes.String, dataField: "userName", cssClass: "dc-userName", headerText: Resources.Common.uploadedBy, defaultWidth: "10%" };
        this.colDate = { number: 7, type: TableColumnTypes.Date, useTime: true, dataField: "date", cssClass: "dc-date", headerText: Resources.Common.date, defaultWidth: "10%" };
        this.colIsPicture = { number: 8, type: TableColumnTypes.Custom, dataField: "isPicture", cssClass: "dc-is-picture", headerText: Resources.Common.image, defaultWidth: "5%", align: TableColumnAlign.Center };
        this.colBlockName = { number: 9, type: TableColumnTypes.String, dataField: "blockName", cssClass: "dc-block-name", headerText: Resources.Massnahme.status, defaultWidth: "0%" };
        this.colFieldName = { number: 10, type: TableColumnTypes.String, dataField: "fieldName", cssClass: "dc-field-name", headerText: Resources.Common.field, defaultWidth: "0%" };
        this.colDelete = { number: 11, type: TableColumnTypes.Custom, dataField: "delete", cssClass: "dc-delete", defaultWidth: "5%", align: TableColumnAlign.Center };
    }

    protected getColumns = (): ITableColumn[] => {
        if (this.props.columns) {
            let columns: ITableColumn[] = [];
            let columnParts = this.props.columns.split(";");

            for (let part of columnParts) {
                switch (part) {
                    case "download":
                        columns.push(this.colDownload);
                        break;
                    case "fileName":
                        columns.push(this.colFileName);
                        break;
                    case "isPicture":
                        columns.push(this.colIsPicture);
                        break;
                    case "blockName":
                        columns.push(this.colBlockName);
                        break;
                    case "fieldName":
                        columns.push(this.colFieldName);
                        break;
                    case "link":
                        this.colLink.defaultWidth = "10%";
                        columns.push(this.colLink);
                        break;
                    case "comment":
                        columns.push(this.colComment);
                        break;
                    case "annotation":
                        columns.push(this.colAnnotation);
                        break;
                    case "userName":
                        columns.push(this.colUserName);
                        break;
                    case "date":
                        columns.push(this.colDate);
                        break;
                    case "delete":
                        if (this.props.allowDelete !== false) {
                            columns.push(this.colDelete);
                        }
                        break;
                    default:
                        break;
                }
            }
            return columns;

        } else {
            this.colLink.defaultWidth = "15%";
            return [
                this.colDownload,
                this.colFileName,
                this.colLink,
                this.colComment,
                this.colAnnotation,
                this.colUserName,
                this.colDate,
                this.colIsPicture
            ];
        }
    }

    protected deleteCallback = (id: string) => {
        this.table.removeRow(id);
        this.props.parentControl?.documentsList?.removeRow(id);
        this.props.parentControl?.decrementDocumentCount();
    }

    protected createTable = () => {
        let tableProps = {
            loadOnCreate: false,
            enableScroll: true,
            enablePaging: false,
            rowsPerPage: 100,
            fixedLayout: this.props.fixed === true ? this.props.fixed : false,
            idField: "id",
            enableSort: false,
            enableFilterPopup: true,
            editType: EditTypes.None,
            settingsName: this.props.settingsName ?? "documentsListMeasure",
            getCustomContent: (field: string, model: any): HTMLElement => {
                if (field == "download") {
                    let icon: HTMLElement = <i className="fal fa-download pointer"></i>;
                    if (model["link"]) {
                        icon = <i class="fal fa-external-link-alt  pointer"></i>;
                    }
                    icon.addEventListener("click", (ev: MouseEvent) => {
                        ev.stopPropagation();
                        if (model["isPicture"]) {
                            Picture.show(model["id"], model["fileName"]);
                        } else if (model["link"]) {

                            window.open(model["link"], "_blank");
                        }
                        else {
                            window.open(app.resolveUrl("~/api/documents/get/" + model["id"]), "_blank");
                        }
                    });
                    return icon;
                } else if (field == "isPicture") {
                    let icon: HTMLElement = <i className="fal is-picture"></i>;
                    if (model[field]) {
                        icon.classList.add("fa-check");
                    }
                    return icon;
                } else if (field == "delete") {
                    let icon: HTMLElement = <i className="fal fa-trash pointer"></i>;
                    icon.addEventListener("click", (ev: MouseEvent) => {
                        ev.stopPropagation();

                        $.ajax({
                            url: app.resolveUrl(`~/api/documents/canDelete/${model["measureId"]}/${model["templateFieldId"]}`),
                            method: "GET",
                            success: (response) => {
                                if (response === true) {
                                    if (this.props.deleteHandler) {
                                        if (confirm(Resources.Massnahme.documentDeleteConfirmation)) {
                                            this.props.deleteHandler(model.id)
                                                .done(() => { this.deleteCallback(model.id) })
                                                .fail((response) => {
                                                    alert(response.statusText + ": " + response.responseText);
                                                });
                                        }
                                    }
                                } else {
                                    document.body.appendChild(
                                        <DynPopup showOkButton={true}
                                            size="dialog"
                                            title={Resources.Common.information}>
                                            {Resources.Massnahme.documentDeleteNoPermission}
                                        </DynPopup>
                                    );
                                }
                            },
                            error: (err) => {
                                console.log(err);
                            }
                        });
                    });
                    return icon;
                }
            },
            rowClickCallback: undefined
        }

        if (this.props.allowEdit !== false) {
            tableProps.rowClickCallback = (ev: MouseEvent) => {

                const id = (ev.target as HTMLElement).closest(".mt-content-row").getAttribute("data-id");
                var model = this.table.getRowModel(id) as IDocumentInfo;

                if (model.measureId && model.templateFieldId) {
                    $.ajax({
                        url: app.resolveUrl(`~/api/documents/canEdit/${model.measureId}/${model.templateFieldId}`),
                        method: "GET",
                        success: (response) => {
                            if (response === true) {
                                this.showEditPopup(ev);
                            } else {
                                document.body.appendChild(
                                    <DynPopup showOkButton={true}
                                        size="dialog"
                                        title={Resources.Common.information}>
                                        {Resources.Massnahme.documentEditNoPermission}
                                    </DynPopup>
                                );
                            }
                        },
                        error: (err) => {
                            console.log(err);
                        }
                    });

                } else {
                    this.showEditPopup(ev);
                }

            }
        }

        this.table = new MsoTable(this.props.parentElement, tableProps);
        this.table.createAll(this.getColumns(), this.data, null, null);
        this.table.settings.sortField = "date";
        this.table.settings.sortAsc = false;
        this.props.parentElement.classList.add("use-ellipsis");
    }

    public getTable = () => {
        return this.table;
    }

    protected showEditPopup(ev: MouseEvent) {
        const id = (ev.target as HTMLElement).closest(".mt-content-row").getAttribute("data-id");
        var row = this.table.getRowModel(id);

        // get disabled state from documents control that contains this document
        let controlParent = document.querySelector(`.doc-row[data-id='${id}']`) as HTMLDivElement;
        let controlFrame = controlParent?.closest(".dyn-control-frame") as HTMLDivElement;
        let disabled: boolean = controlFrame?.classList.contains("dyn-disabled");

        document.body.appendChild(
            <PopupEditDocument
                model={row}
                parentTable={this.table}
                disabled={disabled}
                onDelete={this.deleteCallback}
                allowMove={this.props.allowMove}
                afterMoveEvent={this.props.afterMoveEvent} />
        );
    }
}